import {logAction} from "../../../logging/logEvent";

export default class ExploreNavigation {
    constructor(ourProgrammeContext) {
        this.ourProgrammeContext = ourProgrammeContext;
    }

    backToPortfolioPage(history) {
        const portfolioPath = this.ourProgrammeContext.portfolioOverviewPath();
        const secondGroupingName = this.ourProgrammeContext.context().secondGroupingName;

        return () => {
            history.push(portfolioPath);
            this._logGroupingAction('GROUPING_COLLAPSED', secondGroupingName);
        };
    }

    onSecondaryGrouping(history) {
        return (secondGroupingName) => {
            this._logGroupingAction('SECONDARY_GROUPING_CHOSEN', secondGroupingName);

            const secondaryGroupingPath = this.ourProgrammeContext.secondaryGroupingPath(secondGroupingName);
            history.push(secondaryGroupingPath);
        };
    }

    _logGroupingAction(type, secondGroupingName = null) {
        const {firstGroupingName, portfolioId, portfolioName, companyWithinPortfolioId: companyId = null } = this.ourProgrammeContext.context();
        logAction({
            type: type,
            firstGroupingName: firstGroupingName,
            secondGroupingName: secondGroupingName,
            portfolioId,
            portfolioName,
            companyId: companyId
        });
    }
}

